__turbopack_context__.v({
  "card": "card-module-scss-module__zxWWxW__card",
  "cardContent": "card-module-scss-module__zxWWxW__cardContent",
  "cardDescription": "card-module-scss-module__zxWWxW__cardDescription",
  "cardFooter": "card-module-scss-module__zxWWxW__cardFooter",
  "cardHeader": "card-module-scss-module__zxWWxW__cardHeader",
  "cardTitle": "card-module-scss-module__zxWWxW__cardTitle",
  "error-msg": "card-module-scss-module__zxWWxW__error-msg",
  "errorIcon": "card-module-scss-module__zxWWxW__errorIcon",
  "hint": "card-module-scss-module__zxWWxW__hint",
});
